import TeaserPreviewModal from 'modules/Teasers/Teasers/components/TeaserPreviewModal/TeaserPreviewModal';
import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { TeasersContext, ITeasersContext } from 'modules/Teasers/Teasers/teasersState/teasersContext';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const {
		deleteSelectedItem,
		changeTypeOfModalWindow,
		setTeaserIDForFullInfo,
		typeOfModalWindow,
		teaserIDForFullInfo,
	} = useContext<ITeasersContext>(TeasersContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: typeOfModalWindow || !!teaserIDForFullInfo,
	});

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	const handleCloseVideoModal = useCallback(() => setTeaserIDForFullInfo(''), [setTeaserIDForFullInfo]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteTeaser"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteTeaserSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingTeaser"
			/>
			<TeaserPreviewModal
				isVisible={!!teaserIDForFullInfo}
				teaserIDForFullInfo={teaserIDForFullInfo}
				onClose={handleCloseVideoModal}
			/>
		</div>
	);
};

export default ModalWindows;
